import React from 'react';
import {DataSharingContainer} from '../../Containers/PermissionControlsContainer';

const DataSharing = (props) => {
	return (
		<DataSharingContainer action="show" show=""/>
	);
}
export default DataSharing;